import {remote} from '../constants/environment';
import {IBalanceListResponse} from '../interfaces/services/balances.interface';
import {IBalanceDetail, IClient} from '../interfaces/dtos';
import {defaultHeaders} from './headers';
import {customFetch as fetch, remoteCall} from '../utils/services';

export const getSubClientBalanceList = async (
  client: IClient,
  token: string,
): Promise<IBalanceListResponse> => {
  const remoteURI = remote.getSubClientBalanceListUri(client.id);
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;
          const {balance} = data.payload;

          return {
            success,
            payload: balance as IBalanceDetail[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IBalanceListResponse;
};
